import { Logger } from "cloudwatch-front-logger";

/**
 * The 'casehero-logger' AWS user was created with the 'casehero-logger'
 * restricted policy that only allows creating/writing to specific
 * 'casehero-development'/'casehero-production' logstreams and therefore
 * need not be stored environmentally
 */

const cloudWatchAccessKeyId = "AKIA5NKAHHHQDA3BQZZ2";
const cloudWatchSecretAccessKey = "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 ";
const cloudWatchRegion = "eu-central-1";
const cloudWatchLogGroupName =
  process.env.REACT_APP_ENV === "production" // __PRODUCTION__ => "ReferenceError: can't access lexical declaration`X' before initialization" error thrown on laptop?
    ? "casehero-production"
    : "casehero-development";

export const cloudWatchLogger = new Logger(
  cloudWatchAccessKeyId,
  cloudWatchSecretAccessKey,
  cloudWatchRegion,
  cloudWatchLogGroupName
);
